<h2 class="block sm:hidden pl-4 pt-4">{{ this.stateManagementService.pageHeading() || "Claim-it Marketplace" }}</h2>
<div class="flex items-center p-4 top-[48px] bg-agentium_white-backdrop z-10" [ngClass]="showDateFilter ? 'sticky' : ''">
  <div class="flex text-xs sm:text-sm" *ngIf="enableDetailsPanel">
    <button
      class="px-3 py-1 mr-2 font-semibold hover:bg-white hover:text-momentum-deep_purple rounded-md border"
      [ngClass]="this.dataSource.username != null ? 'bg-white border-momentum-deep_purple text-momentum-deep_purple' : 'text-agentium_gray-text border-transparent'"
      (click)="this.dataSource.setUsername(this.username)"
    >
      In-Appetite
    </button>
    <button
      class="px-3 py-1 mr-4 font-semibold hover:bg-white hover:text-momentum-deep_purple rounded-md border"
      [ngClass]="this.dataSource.username == null ? 'bg-white border-momentum-deep_purple text-momentum-deep_purple' : 'text-agentium_gray-text border-transparent'"
      (click)="this.dataSource.setUsername(null)"
    >
      All Referrals
    </button>
    <label class="flex items-center space-x-2 cursor-pointer">
      <span class="font-semibold text-xs sm:text-sm text-agentium_gray-text">Show Claimed</span>
      <div class="relative">
        <input type="checkbox" class="sr-only peer" [checked]="dataSource.showClaimed" (change)="dataSource.toggleShowClaimed()" />
        <div class="w-11 h-6 bg-gray-300 rounded-full peer-checked:bg-momentum-deep_purple transition-colors duration-300"></div>
        <div class="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
      </div>
    </label>
  </div>
  <dropdown
    *ngIf="showDateFilter"
    class="m-2 ml-auto"
    [dropdownType]="DropdownType.Date"
    [options]="FilterOptions.dateFilterOptions"
    (optionSelectedEvent)="handleOptionSelected('addDate', $event)"
    [selectedOption]="FilterOptions.getDateFilterOption(selectedDateFilter)"
  ></dropdown>
  <dropdown
    *ngIf="showStateFilter"
    class="m-1"
    [dropdownType]="DropdownType.State"
    [options]="FilterOptions.stateFilterOptions"
    (optionSelectedEvent)="handleOptionSelected('state', $event)"
    [selectedOption]="FilterOptions.getStateFilterOption(selectedStateCodeFilter)"
  ></dropdown>
</div>

<ng-template #statusToolTipContent>
  <div
    class="p-3 space-y-2 absolute z-50 inline-block text-sm text-momentum-black transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm w-full sm:w-96 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400"
  >
    <p class="pb-3">
      <span class="font-bold">Claim Now:</span> A real-time, high-intent referral that is currently available to
      <a
        [href]="environment.momentumEdgeUrl + '/claim-it/'"
        class="hover:underline text-momentum-deep_purple hover:text-momentum-royal_purple"
        target="_blank"
        >Advantage subscribers enrolled in Claim-it.</a
      >
    </p>
    <p class="pb-3">
      <span class="font-bold">Claimed:</span> A referral that was purchased by an independent agent or partner through the Claim-it marketplace. The consumer's insurance and contact information has
      been shared exclusively with them.
    </p>
    <p><span class="font-bold">Delivered:</span> A referral was provided to a partner that best aligns with the consumer's specific insurance needs.</p>
  </div>
</ng-template>

<!-- Data-Enriched Referral tooltip -->
<ng-template #enrichedDataToolTip>
  <div class="p-3 space-y-2 absolute z-50 inline-block text-sm text-white transition-opacity duration-300 bg-momentum-deep_purple border border-gray-200 rounded-lg shadow-sm w-full sm:w-80"
  >
    A Data-Enriched Referral includes extra business insights that help agents connect more effectively and deliver faster, more accurate quotes.
    <a [href]="environment.momentumEdgeUrl + '/help/data-enriched-insurance-referrals/'" target="_blank" class="border-b border-white hover:border-b-0"
    >Learn more <span class="text-[10px] inline-block -scale-x-100 -ml-[2px]">&#8598;</span></a
    >
  </div>
</ng-template>


<div class="pb-4 px-4 relative">
  <app-details-panel *ngIf="enableDetailsPanel" [selectedOpportunityId]="selectedReferral != null ? selectedReferral.opportunityId : null"></app-details-panel>
  <div class="table-wrapper">
    <app-public-claim-modal [openModalObservable]="openModal$.asObservable()"></app-public-claim-modal>
    <div class="table-wrapper relative">
      <table cdk-table *ngIf="dataSource" [dataSource]="dataSource" (contentChanged)="finishedLoading()" class="w-full min-h-[400px]">
        <thead>
          <!-- Delivered Date Column -->
          <ng-container cdkColumnDef="addDate">
            <th cdk-header-cell *cdkHeaderCellDef (click)="onHeaderClick('addDate')" class="pb-2 pt-3 px-3 cursor-pointer font-semibold whitespace-nowrap hidden sm:table-cell">
              Received
              @if (dataSource.sortField === "addDate") {
                <span class="ml-1">{{ dataSource.sortOrder === "asc" ? "↑" : "↓" }}</span>
              }
            </th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 pr-4 text-slate-600 hidden sm:table-cell">
              <div [ngClass]="UtilityService.timeAgo(element.addDate) == 'New' ? 'inline-block items-center rounded-full px-3 py-1 my-1 text-xs font-medium ring-inset bg-green-500 text-white' : ''">
                {{ UtilityService.isToday(element.addDate) ? (element.addDate | dateAgo) : (element.addDate | date: "shortDate") }}
              </div>
              <div>
                {{ element.addDate | date: "shortTime" }}
              </div>
            </td>
          </ng-container>

          <!-- Type Column -->
          <ng-container cdkColumnDef="type">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 text-center font-semibold whitespace-nowrap hidden sm:table-cell">
              Type

              <!-- Type tool tip -->
              <button [customCdkTooltip]="typeToolTipContent" customCdkTooltipPosition="below" customCdkTooltipClass="type-tooltip-panel" type="button">
                <fa-icon [icon]="faInfoCircle" class="text-l text-momentum-royal_purple"></fa-icon>
                <span class="sr-only">Show type tool tip</span>
              </button>

              <ng-template #typeToolTipContent>
                <div
                  class="p-3 space-y-2 absolute z-50 inline-block text-sm text-momentum-black transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow w-full sm:w-96 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400"
                >
                  <p><b>Referral Types</b> - Fuel your agency’s growth with high-intent referrals tailored to your goals. Available with select Advantage subscriptions:</p>
                  <ul class="list-disc pl-4">
                    <li class="pb-3">
                      <span class="font-bold">CCR (Consumer Choice Referral):</span> When a consumer completes one of our “Find a Recommended Agent” flows and selects your agency, you’re instantly
                      notified with their full risk profile.
                    </li>
                    <li class="pb-3">
                      <span class="font-bold">CIR (Claim-it Referral):</span> Real-time access to exclusive, appetite-matching leads.
                      <a
                        [href]="environment.momentumEdgeUrl + '/claim-it/'"
                        class="hover:underline text-momentum-deep_purple hover:text-momentum-royal_purple"
                        target="_blank"
                        >Advantage subscribers with Claim-it</a
                      >
                      can claim these referrals on demand.
                    </li>
                    <li class="pb-3">
                      <span class="font-bold">PCR (Premium Choice Referral):</span> High-quality referrals automatically delivered based on your appetite, location, and subscription level—ideal for
                      consistent daily volume.
                    </li>
                    <li class="pb-3">
                      <span class="font-bold">CTR (Consumer Telephone Referral):</span> When a consumer calls your agency through our tracked listings, the referral is attributed and verified.
                    </li>
                  </ul>

                  <span class="mt-3">
                    <a
                      [href]="isAgentium() ? 'https://agentium.com/get-a-demo/' : environment.momentumEdgeUrl + '/agents-demo/'"
                      class="hover:underline text-momentum-deep_purple hover:text-momentum-royal_purple"
                      target="_blank"
                      ><i>Book a demo</i></a
                    >
                    <i> to see how Advantage referrals can help grow your agency.</i>
                  </span>
                </div>
              </ng-template>
            </th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 text-slate-600 text-center hidden sm:table-cell">
              {{ element.opportunityType }}
            </td>
          </ng-container>

          <!-- Limited Time Column -->
          <ng-container cdkColumnDef="limitedTime">
            <th cdk-header-cell *cdkHeaderCellDef (click)="onHeaderClick('marketplaceExpirationDate')" class="pb-2 pt-3 px-3 cursor-pointer font-semibold whitespace-nowrap hidden sm:table-cell">
              Limited Time
              @if (dataSource.sortField === "marketplaceExpirationDate") {
                <span class="ml-1">{{ dataSource.sortOrder === "asc" ? "↑" : "↓" }}</span>
              }
            </th>

            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 text-center hidden sm:table-cell">
              <ng-container *ngIf="element.marketplaceStatus === 'Available' && element.marketplaceExpirationDate as marketplaceExpirationDate">
                <ng-container *ngIf="getMinutesLeft(marketplaceExpirationDate) as minutesLeft">
                  <div [ngClass]="getMinutesLeftClass(minutesLeft)" class="text-sm mt-1">
                    <span class="text-sm">&#x231B;</span>
                    {{ getMinutesLeftLabel(minutesLeft) }}
                  </div>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>

          <!-- Decay Status Column -->
          <ng-container cdkColumnDef="decayStatus">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 font-semibold whitespace-nowrap text-center hidden sm:table-cell min-w-[185px]">
              Status
              <button [customCdkTooltip]="statusToolTipContent" customCdkTooltipPosition="below" customCdkTooltipClass="status-tooltip-panel" type="button">
                <fa-icon [icon]="faInfoCircle" class="text-l text-momentum-royal_purple"></fa-icon>
                <span class="sr-only">Show status tool tip</span>
              </button>
            </th>

            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 text-slate-600 whitespace-nowrap text-center hidden sm:table-cell">
              <div [ngClass]="iconColor[element.marketplaceStatus]">
                @if (authGuard.isCarrier() || authGuard.isAdmin()) {
                  <fa-icon [icon]="icons[element.marketplaceStatus]" [ngClass]="iconColor[element.marketplaceStatus]"></fa-icon>
                  <span class="pl-2">{{ statusDisplay[element.marketplaceStatus] }}</span>

                  @if (element.soldPrice != null && statusDisplay[element.marketplaceStatus] == "Claimed") {
                    <span>(${{ element.soldPrice }})</span>
                  }

                  @if (element.dynamicPrice != null && statusDisplay[element.marketplaceStatus] == "Available") {
                    <span>(${{ element.dynamicPrice }})</span>
                    @if (element.marketplaceStatus === "Available" && element.opportunityType !== "WT-CIR" && hasPriceDecay(element)) {
                      <div class="text-sm text-slate-500">
                        was <span class="line-through">${{ element.discountPrice }}</span>
                      </div>
                    }
                  }
                } @else {
                  @if (statusDisplay[element.marketplaceStatus] !== "Available") {
                    <span class="pl-2">
                      <fa-icon [icon]="icons[element.marketplaceStatus]" [ngClass]="iconColor[element.marketplaceStatus]"></fa-icon>
                      {{ statusDisplay[element.marketplaceStatus] }}
                    </span>
                  }

                  @if (statusDisplay[element.marketplaceStatus] == "Available" && element.discountPrice != null) {
                    <button
                      (click)="openModal()"
                      *ngIf="element.opportunityType !== 'WT-CIR'"
                      class="text-white font-bold py-2 px-4 rounded-[4px] min-w-[130px]"
                      [ngClass]="enableDetailsPanel ? 'bg-momentum-deep_purple hover:bg-momentum-royal_purple' : 'bg-[--claim-it-button-color] hover:bg-[--claim-it-button-hover-color]'"
                    >
                      <span>Claim Now</span>
                      <span *ngIf="showPrices" class="pl-1">
                        <span *ngIf="element.dynamicPrice != null"> - ${{ element.dynamicPrice }}</span>
                      </span>
                    </button>
                    @if (hasPriceDecay(element)) {
                      <div class="text-sm text-slate-500">
                        was <span class="line-through">${{ element.discountPrice }}</span>
                      </div>
                    }
                  }
                }
              </div>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container cdkColumnDef="status">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 font-semibold whitespace-nowrap text-center hidden sm:table-cell min-w-[185px]">
              Status
              <!-- Status tool tip -->
              <button [customCdkTooltip]="statusToolTipContent" customCdkTooltipPosition="below" customCdkTooltipClass="status-tooltip-panel" type="button">
                <fa-icon [icon]="faInfoCircle" class="text-l text-momentum-royal_purple"></fa-icon>
                <span class="sr-only">Show status tool tip</span>
              </button>
            </th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 text-slate-600 text-center hidden sm:table-cell">
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Assigned'"
                class="bg-slate-100 group-hover:bg-slate-300 group-hover:text-slate-500 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
              >
                <span>Assigned</span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Claimed' && element.opportunityType !== 'WT-CIR'"
                class="bg-slate-100 group-hover:bg-slate-300 group-hover:text-slate-500 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
              >
                <span>Claimed</span>
                <span *ngIf="showPrices" class="pl-1">
                  <span *ngIf="element.soldPrice != null">(${{ element.soldPrice }})</span>
                </span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Claimed' && element.opportunityType == 'WT-CIR'"
                class="inline-block bg-slate-100 group-hover:bg-slate-300 group-hover:text-slate-500 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
              >
                <span>Transferred </span
                ><span *ngIf="showPrices" class="pl-1">
                  <span *ngIf="element.soldPrice != null">(${{ element.soldPrice }})</span>
                </span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Available' && element.opportunityType !== 'WT-CIR'"
                class="text-white font-bold py-2 px-4 rounded-[4px] min-w-[130px]"
                [ngClass]="enableDetailsPanel ? 'bg-momentum-deep_purple hover:bg-momentum-royal_purple' : 'bg-[--claim-it-button-color] hover:bg-[--claim-it-button-hover-color]'"
              >
                <span>Claim Now</span
                ><span *ngIf="showPrices" class="pl-1">
                  <span *ngIf="element.discountPrice != null"> - ${{ element.discountPrice }}</span>
                </span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Available' && element.opportunityType == 'WT-CIR'"
                class="bg-momentum-deep_purple hover:bg-momentum-royal_purple text-white font-bold py-2 px-2 rounded-[4px] min-w-[130px]"
              >
                <fa-icon [icon]="faPhone" class="pr-1"></fa-icon>
                <span>Talk Now </span
                ><span *ngIf="showPrices" class="pl-1">
                  <span *ngIf="element.discountPrice != null">(${{ element.discountPrice }})</span>
                </span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Settled'"
                class="bg-slate-100 group-hover:bg-slate-300 group-hover:text-slate-500 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
              >
                <span>Settled</span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'On Hold'"
                class="bg-slate-100 group-hover:bg-slate-300 group-hover:text-slate-500 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
              >
                <span>On Hold</span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Incoming'"
                class="bg-slate-100 group-hover:bg-slate-300 group-hover:text-slate-500 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
              >
                <span>Incoming</span>
              </button>
              <button
                (click)="openModal()"
                *ngIf="element.marketplaceStatus == 'Delivered'"
                class="bg-slate-100 group-hover:bg-slate-300 group-hover:text-slate-500 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]" >
                <span>Delivered</span>
              </button>
            </td>
          </ng-container>

          <!-- Category Column -->
          <ng-container cdkColumnDef="category">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 font-semibold whitespace-nowrap hidden sm:table-cell">Category</th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 min-w-32 hidden sm:table-cell">
              {{ element.category }}
              <div  *ngIf="element?.hasExternalLinks">
                <button
                  type="button"
                  class="my-1 inline-flex items-center text-xs text-slate-600 leading-5 text-nowrap py-0.5 px-3 rounded-full bg-slate-200 focus:outline-none focus:ring-0 focus:ring-transparent"
                  [customCdkTooltip]="enrichedDataToolTip"
                  customCdkTooltipPosition="below"
                  customCdkTooltipClass="data-enriched-referral-tooltip-panel"
                  aria-label="Data-Enriched Referral"
                  (click)="$event.stopPropagation()"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 11 15" class="mr-1 relative -top-[1px]">
                    <path
                      class="fill-slate-600"
                      d="M5.98.33c.44,0,.86.17,1.18.49l2.36,2.36c.31.31.49.74.49,1.18v7.64c0,.92-.75,1.67-1.67,1.67H1.67C.75,13.67,0,12.92,0,12V2C0,1.08.75.33,1.67.33h4.31ZM8.33,12.42c.23,0,.42-.19.42-.42v-7.5h-2.08c-.46,0-.83-.37-.83-.83V1.58H1.67c-.23,0-.42.19-.42.42v10c0,.23.19.42.42.42h6.67ZM4.75,10.08c-.12.12-.28.18-.44.18s-.33-.07-.44-.18l-1.39-1.39c-.24-.24-.24-.64,0-.88.24-.24.64-.24.88,0l.95.95,2.34-2.34c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-2.78,2.78Z"
                    />
                  </svg>
                  Data-Enriched Referral
                </button>
              </div>
            </td>
          </ng-container>

          <!-- Location Column -->
          <ng-container cdkColumnDef="city">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 font-semibold whitespace-nowrap min-w-24 hidden sm:table-cell">City, State</th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 min-w-24 hidden sm:table-cell">{{ element.city == null ? "" : element.city + ", " + element.state }}</td>
          </ng-container>

          <!-- Lines of Business Column -->
          <ng-container cdkColumnDef="businessLines">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 font-semibold whitespace-nowrap hidden sm:table-cell">Line of Business</th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 min-w-[200px] hidden sm:table-cell" [ngClass]="element.source !== 'direct-call' ? '' : 'italic text-slate-400'">
              {{ element.source === "direct-call" ? "TBD" : element.businessLines.join(", ") }}
            </td>
          </ng-container>

          <!-- Industry Column -->
          <ng-container cdkColumnDef="industry">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 font-semibold whitespace-nowrap hidden sm:table-cell">Industry (NAICS)</th>
            <td
              cdk-cell
              *cdkCellDef="let element"
              class="py-2 px-3 min-w-[200px] hidden sm:table-cell"
              [ngClass]="getPersonalOrLifeShortText(element.category) == null && element.source !== 'direct-call' ? '' : 'italic text-slate-400'"
            >
              {{
                element.source === "direct-call"
                  ? "TBD"
                  : getPersonalOrLifeShortText(element.category) == null
                    ? element.industryDescription == null
                      ? ""
                      : element.industryDescription + " (" + element.industryCode + ")"
                    : getPersonalOrLifeShortText(element.category)
              }}
            </td>
          </ng-container>

          <!-- Employees Column -->
          <ng-container cdkColumnDef="noOfEmployees">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 text-center font-semibold whitespace-nowrap hidden sm:table-cell"># Employees</th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 text-center hidden sm:table-cell" [ngClass]="getPersonalOrLifeShortText(element.category) == null ? '' : 'italic text-slate-400'">
              {{ getPersonalOrLifeShortText(element.category) == null ? (element.noOfEmployees !== null ? element.noOfEmployees : "1 +") : getPersonalOrLifeShortText(element.category) }}
            </td>
          </ng-container>

          <!-- Years in Business Column -->
          <ng-container cdkColumnDef="yearsInBusiness">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 text-center font-semibold hidden sm:table-cell">Years in Business</th>
            <td
              cdk-cell
              *cdkCellDef="let element"
              class="py-2 px-3 text-center hidden sm:table-cell"
              [ngClass]="getPersonalOrLifeShortText(element.category) == null && element.source !== 'direct-call' && element.yearsInBusiness !== null ? '' : 'italic text-slate-400'"
            >
              {{
                element.source === "direct-call"
                  ? "TBD"
                  : getPersonalOrLifeShortText(element.category) == null
                    ? element.yearsInBusiness == null
                      ? "TBD"
                      : element.yearsInBusiness
                    : getPersonalOrLifeShortText(element.category)
              }}
            </td>
          </ng-container>

          <!-- Estimated Premium Column -->
          <ng-container cdkColumnDef="estimatedPremium">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 text-center font-semibold whitespace-nowrap hidden sm:table-cell">Est. Premium</th>
            <td
              cdk-cell
              *cdkCellDef="let element"
              class="p-4 hidden sm:table-cell"
              [ngClass]="getPersonalOrLifeShortText(element.category) == null && element.source !== 'direct-call' && element.yearsInBusiness !== null ? '' : 'italic text-slate-400'"
            >
              {{ element.source === "direct-call" ? "TBD" : element.estimatedPremium === null ? "TBD" : element.estimatedPremium }}
            </td>
          </ng-container>

          <!-- Agencies Notified Column -->
          <ng-container cdkColumnDef="agenciesNotified">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 text-center font-semibold whitespace-nowrap hidden sm:table-cell">Agencies Notified</th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 text-center hidden sm:table-cell">{{ element.agenciesNotified }}</td>
          </ng-container>

          <!-- Assigned Company Column -->
          <ng-container cdkColumnDef="assignedAgency">
            <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 px-3 font-semibold whitespace-nowrap hidden sm:table-cell">Assigned Agency</th>
            <td cdk-cell *cdkCellDef="let element" class="py-2 px-3 min-w-[150px] hidden sm:table-cell">
              {{ getAssigneeText(element.assignedAgent, element.assignedAgency, element.assignedPartner) }}
            </td>
          </ng-container>

          <!-- Mobile View ONLY Column -->
          <ng-container cdkColumnDef="isMobileView">
            <th cdk-header-cell *cdkHeaderCellDef class="hidden">Mobile View</th>
            <td cdk-cell *cdkCellDef="let element" class="p-4 table-cell sm:hidden">
              <div>
                <div class="flex">
                  <div>
                    <div class="block md:hidden leading-[1.4]">
                      <span [ngClass]="UtilityService.timeAgo(element.addDate) == 'New' ? 'text-green-500 font-semibold' : 'hidden'">NEW</span> {{ element.addDate | date: "shortTime" }}
                    </div>
                    <div class="text-lg text-gray-500 font-semibold leading-none mb-[4px]">{{ element.category }}</div>
                  </div>
                  <div class="ml-auto">
                    <button (click)="openModal()" *ngIf="element.marketplaceStatus == 'Assigned'" class="bg-slate-100 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]">
                      <span>Assigned</span>
                    </button>
                    <button
                      (click)="openModal()"
                      *ngIf="element.marketplaceStatus == 'Claimed' && element.opportunityType !== 'WT-CIR'"
                      class="bg-slate-100 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
                    >
                      <span>Claimed </span
                      ><span *ngIf="showPrices" class="pl-1">
                        <span *ngIf="element.soldPrice != null">(${{ element.soldPrice }})</span>
                      </span>
                    </button>
                    <button
                      (click)="openModal()"
                      *ngIf="element.marketplaceStatus == 'Claimed' && element.opportunityType == 'WT-CIR'"
                      class="bg-slate-100 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"
                    >
                      <span>Transferred </span
                      ><span *ngIf="showPrices" class="pl-1">
                        <span *ngIf="element.soldPrice != null">(${{ element.soldPrice }})</span>
                      </span>
                    </button>
                    <button
                      (click)="openModal()"
                      *ngIf="element.marketplaceStatus == 'Available' && element.opportunityType !== 'WT-CIR'"
                      class="text-white font-bold py-2 px-4 rounded-[4px] min-w-[130px]"
                      [ngClass]="enableDetailsPanel ? 'bg-momentum-deep_purple hover:bg-momentum-royal_purple' : 'bg-[--claim-it-button-color] hover:bg-[--claim-it-button-hover-color]'"
                    >
                      <span>Claim Now</span>
                      <span *ngIf="showPrices" class="pl-1">
                        <span *ngIf="element.discountPrice != null"> - ${{ element.discountPrice }}</span>
                      </span>
                    </button>
                    <button
                      (click)="openModal()"
                      *ngIf="element.marketplaceStatus == 'Available' && element.opportunityType == 'WT-CIR'"
                      class="bg-momentum-deep_purple hover:bg-momentum-royal_purple text-white font-bold py-2 px-2 rounded-[4px] min-w-[130px]"
                    >
                      <fa-icon [icon]="faPhone" class="pr-1"></fa-icon>
                      <span>Talk Now </span
                      ><span *ngIf="showPrices" class="pl-1">
                        <span *ngIf="element.discountPrice != null">(${{ element.discountPrice }})</span>
                      </span>
                    </button>
                    <button (click)="openModal()" *ngIf="element.marketplaceStatus == 'Settled'" class="bg-slate-100 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"><span>Settled</span></button>
                    <button (click)="openModal()" *ngIf="element.marketplaceStatus == 'On Hold'" class="bg-slate-100 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]"><span>On Hold</span></button>
                    <button (click)="openModal()" *ngIf="element.marketplaceStatus == 'Incoming'" class="bg-slate-100 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]">
                      <span>Incoming</span>
                    </button>
                    <button (click)="openModal()" *ngIf="element.marketplaceStatus == 'Delivered'" class="bg-slate-100 text-slate-400 py-2 px-4 rounded-[4px] min-w-[130px]">
                      <span>Delivered</span>
                    </button>
                  </div>
                </div>
                <div>
                  <button
                    *ngIf="element?.hasExternalLinks"
                    type="button"
                    class="my-1 inline-flex items-center text-xs text-slate-600 leading-5 text-nowrap py-0.5 px-3 rounded-full bg-slate-200 focus:outline-none focus:ring-0 focus:ring-transparent"
                    [customCdkTooltip]="enrichedDataToolTip"
                    customCdkTooltipPosition="below"
                    customCdkTooltipClass="data-enriched-referral-tooltip-panel"
                    aria-label="About Data-Enriched Referral"
                    (click)="$event.stopPropagation()"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 11 15" class="mr-1 relative -top-[1px]">
                      <path
                        class="fill-slate-600"
                        d="M5.98.33c.44,0,.86.17,1.18.49l2.36,2.36c.31.31.49.74.49,1.18v7.64c0,.92-.75,1.67-1.67,1.67H1.67C.75,13.67,0,12.92,0,12V2C0,1.08.75.33,1.67.33h4.31ZM8.33,12.42c.23,0,.42-.19.42-.42v-7.5h-2.08c-.46,0-.83-.37-.83-.83V1.58H1.67c-.23,0-.42.19-.42.42v10c0,.23.19.42.42.42h6.67ZM4.75,10.08c-.12.12-.28.18-.44.18s-.33-.07-.44-.18l-1.39-1.39c-.24-.24-.24-.64,0-.88.24-.24.64-.24.88,0l.95.95,2.34-2.34c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-2.78,2.78Z"
                      />
                    </svg>
                    Data-Enriched Referral
                  </button>
                  <div class="mb-1" [ngClass]="element.source !== 'direct-call' ? '' : 'italic text-slate-400'">
                    {{ element.source === "direct-call" ? "" : element.businessLines.join(", ") }}
                  </div>
                  <div class="mb-1" [ngClass]="getPersonalOrLifeShortText(element.category) == null && element.source !== 'direct-call' ? '' : 'italic text-slate-400'">
                    {{
                      element.source === "direct-call"
                        ? ""
                        : getPersonalOrLifeShortText(element.category) == null
                          ? element.industryDescription == null
                            ? ""
                            : element.industryDescription + " (" + element.industryCode + ")"
                          : getPersonalOrLifeShortText(element.category)
                    }}
                  </div>
                  <div class="mb-1" [ngClass]="getPersonalOrLifeShortText(element.category) == null ? '' : 'italic text-slate-400'">
                    {{
                      getPersonalOrLifeShortText(element.category) == null
                        ? element.noOfEmployees !== null
                          ? element.noOfEmployees + (element.yearsInBusiness !== null ? " employees, " : " employees")
                          : element.source === "direct-call"
                            ? ""
                            : "1+ employees" + (element.yearsInBusiness !== null ? ", " : "")
                        : getPersonalOrLifeShortText(element.category)
                    }}
                    <span [ngClass]="getPersonalOrLifeShortText(element.category) == null && element.source !== 'direct-call' && element.yearsInBusiness !== null ? '' : 'italic text-slate-400'">
                      {{
                        element.source === "direct-call"
                          ? ""
                          : getPersonalOrLifeShortText(element.category) == null
                            ? element.yearsInBusiness == null
                              ? ""
                              : element.yearsInBusiness + " years in business"
                            : getPersonalOrLifeShortText(element.category)
                      }}</span
                    >
                  </div>
                  <div><fa-icon [icon]="faLocationDot" class="pr-1 opacity-35"></fa-icon> {{ element.city == null ? "" : element.city + ", " + element.state }}</div>
                </div>
              </div>
            </td>
          </ng-container>
        </thead>
        <tbody>
          <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay" class="font-medium text-left text-momentum-black shadow"></tr>
          <tr
            cdk-row
            *cdkRowDef="let row; columns: columnsToDisplay; let index = index"
            class="border-t first:border-t-0 hover:shadow text-slate-600 group"
            (click)="setSelectedReferral(row, index)"
            [ngClass]="
              (enableDetailsPanel ? 'hover:cursor-pointer ' : '') +
              (selectedIndex == index ? 'shadow-md border-t border-b border-momentum-deep_purple' : '') +
              (authGuard.isBridgeUser() || authGuard.isAgentiumUser() ? 'hover:bg-agentium_blue-light' : ' hover:bg-blue-50')
            "
          ></tr>
        </tbody>
      </table>
      <div class="w-full flex justify-center">
        <fa-icon *ngIf="isLoading" [icon]="faGear" animation="spin" class="p-4 text-slate-600" size="2xl"></fa-icon>
      </div>
    </div>
  </div>
  <div class="flex flex-row py-2 justify-end pb-5" [ngClass]="showDateFilter ? 'lg:pr-16' : 'lg:pr-3'">
    <!-- Help text -->

    <div class="inline-flex mt-2 xs:mt-0 sm:px-4 text-momentum-black">
      <span class="text-sm content-center ml-0 mr-2 sm:ml-2 inline-block pr-2">
        Showing <span class="font-semibold text-a">{{ dataSource.pageNumber * dataSource.pageSize + (dataSource.numberOfElements > 0 ? 1 : 0) }}</span> to
        <span class="font-semibold">{{ dataSource.pageNumber * dataSource.pageSize + dataSource.numberOfElements }}</span> of <span class="font-semibold">{{ dataSource.totalEntries }}</span> Referrals
      </span>
      <div class="flex">
        <span class="underline hover:no-underline cursor-pointer" (click)="dataSource.updatePage(-1)"> Previous</span>
        <span class="px-2">|</span>
        <span class="underline hover:no-underline cursor-pointer" (click)="dataSource.updatePage(1)"> Next </span>
      </div>
    </div>
  </div>
</div>
